
import React, { Component, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import "./App.css";

import { Home } from "./Home";
import { Business } from "./Business";
import { Accessibility } from "./Accessibility";
import { Permitforuseexceeds } from "./Permitforuseexceeds";
import About from "./About";
import Contact from "./Contact";
import { Websiteterms } from "./Websiteterms";
import { customers } from "./customers";

import { NavigationBar } from "./components/NavigationBar";
import Navigationdowen from "./components/Navigationdowen";
import Screen from "./components/Screen";
import HamburgerMenu from "./components/Nav/HamburgerMenu";

import { AccessibilityWidget } from "react-accessibility";
import WhatsAppBot from "./WhatsAppBot";
import CookieConsent from "./CookieConsent";

const SITE_URL = "https://rishuy-asakim.co.il";
const SITE_NAME = "רישוי עסקים ישראל";
const SITE_IMAGE = `${SITE_URL}/logo192.png`;

const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  max-height: 90px;
  min-height: 90px;
  overflow: hidden;
  transition: all 0.3s ease;
`;

const seoPages = {
  "/": {
    title: "רישוי עסקים בישראל | שני אדרעי – מומחית לרישוי עסקים",
    description:
      "שני אדרעי מעניקה ליווי מקצועי בתהליכי רישוי עסקים בישראל, הכנת בקשות לרישיון עסק, טיפול מול רשויות מקומיות, מחלקות הנדסה ומשרדי ממשלה.",
  },

  "/business": {
    title: "תהליך רישוי עסקים | הנדסה, משרד הבריאות וביקורת עסקים",
    description:
      "מדריך לתהליך רישוי עסקים: בדיקות מחלקת הנדסה, דרישות משרד הבריאות, הגשת בקשה לרישיון עסק, היתרים וביקורת עסקים ברשות המקומית.",
  },

  "/accessibility": {
    title: "הצהרת נגישות | רישוי עסקים ישראל",
    description:
      "הצהרת הנגישות של אתר רישוי עסקים ישראל. מידע על התאמות הנגישות באתר ודרכי יצירת קשר בנושא נגישות.",
  },

  "/permit-for-use": {
    title: "היתר לשימוש חורג ורישוי עסקים במבנים לא מוסדרים",
    description:
      "מידע על רישוי עסקים במבנים ללא היתר בנייה, התאמת השימוש לתב״ע, היתר לשימוש חורג, תיקון 101 לחוק התכנון והבנייה והליכי רישוי זמין.",
  },

  "/about": {
    title: "אודות שני אדרעי | מומחית לרישוי עסקים",
    description:
      "הכירו את שני אדרעי ואת פעילותה בתחום רישוי העסקים בישראל, כולל ליווי בעלי עסקים בהתנהלות מול הרשויות ובהליכי רישוי.",
  },

  "/contact": {
    title: "יצירת קשר | שני אדרעי – רישוי עסקים",
    description:
      "צרו קשר עם שני אדרעי לקבלת מידע, ייעוץ וליווי מקצועי בנושא רישיון עסק ותהליכי רישוי עסקים בישראל.",
  },

  "/customers": {
    title: "המלצות לקוחות | רישוי עסקים ישראל",
    description:
      "קראו המלצות וחוות דעת של לקוחות שקיבלו ליווי וסיוע בתהליכי רישוי עסקים מול הרשויות.",
  },

  "/articles": {
    title: "מאמרים ומידע מקצועי בנושא רישוי עסקים",
    description:
      "מאמרים ומידע מקצועי לבעלי עסקים בנושא רישוי עסקים, הוצאת רישיון עסק, דרישות הרשויות ותהליכי הסדרה.",
  },
};

const normalizePath = (pathname) => {
  const decodedPath = decodeURIComponent(pathname || "/");
  const cleanPath = decodedPath.replace(/\/+$/, "").toLowerCase();

  return cleanPath || "/";
};

// גלילה לראש הדף בכל מעבר בין עמודים
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  return null;
}

class AppContent extends Component {
  render() {
    const currentPath = normalizePath(this.props.location.pathname);

    const currentSeo = seoPages[currentPath];
    const isKnownPage = Boolean(currentSeo);

    const pageSeo = currentSeo || {
      title: "העמוד לא נמצא | רישוי עסקים ישראל",
      description: "העמוד המבוקש אינו זמין באתר רישוי עסקים ישראל.",
    };

    const canonicalUrl = `${SITE_URL}${currentPath}`;

    return (
      <>
        <Helmet>
          <title>{pageSeo.title}</title>

          <meta
            name="description"
            content={pageSeo.description}
          />

          <meta
            name="robots"
            content={
              isKnownPage
                ? "index, follow, max-image-preview:large"
                : "noindex, follow"
            }
          />

          <link
            rel="canonical"
            href={canonicalUrl}
          />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={pageSeo.title} />
          <meta
            property="og:description"
            content={pageSeo.description}
          />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:image" content={SITE_IMAGE} />
          <meta property="og:image:alt" content={SITE_NAME} />
          <meta property="og:site_name" content={SITE_NAME} />
          <meta property="og:locale" content="he_IL" />

          <meta
            name="twitter:card"
            content="summary_large_image"
          />
          <meta
            name="twitter:title"
            content={pageSeo.title}
          />
          <meta
            name="twitter:description"
            content={pageSeo.description}
          />
          <meta
            name="twitter:image"
            content={SITE_IMAGE}
          />
        </Helmet>

        <NavigationBar />

        <HamburgerMenu />

        <Screen />

        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/business" component={Business} />
          <Route exact path="/accessibility" component={Accessibility} />
          <Route exact path="/permit-for-use" component={Permitforuseexceeds} />
          <Route exact path="/about" component={About} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/customers" component={customers} />
          <Route exact path="/articles" component={Websiteterms} />
        </Switch>

        <AccessibilityWidget />
        <WhatsAppBot />
        <CookieConsent />

        <Navigationdowen>
          <AdsWrapper />
        </Navigationdowen>
      </>
    );
  }
}

const AppWithRouter = withRouter(AppContent);

class App extends Component {
  render() {
    return (
      <Router>
        <ScrollToTop />
        <AppWithRouter />
      </Router>
    );
  }
}

export default App;
